// Video metadata extraction utility

interface VideoMetadata {
  title?: string;
  description?: string;
  thumbnail?: string;
  duration?: number;
  source?: string;
  error?: string;
}

/**
 * Extract video metadata from popular video platforms
 * Currently supports YouTube and Vimeo
 */
export async function extractVideoMetadata(url: string): Promise<VideoMetadata> {
  try {
    const parsed = new URL(url);
    
    // YouTube
    if (parsed.hostname.includes('youtube.com') || parsed.hostname.includes('youtu.be')) {
      const videoId = getYouTubeVideoId(url);
      if (videoId) {
        return {
          title: `YouTube Video: ${videoId}`,
          thumbnail: `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
          source: 'youtube',
        };
      }
    }

    // Vimeo
    if (parsed.hostname.includes('vimeo.com')) {
      const vimeoId = parsed.pathname.split('/')[2];
      if (vimeoId) {
        return {
          title: `Vimeo Video: ${vimeoId}`,
          source: 'vimeo',
        };
      }
    }

    return { error: 'Unsupported video platform' };
  } catch {
    return { error: 'Invalid URL' };
  }
}

export function getYouTubeVideoId(url: string): string | null {
  try {
    const parsed = new URL(url);
    
    // youtu.be short URL
    if (parsed.hostname === 'youtu.be') {
      return parsed.pathname.slice(1);
    }
    
    // youtube.com watch URL
    if (parsed.hostname.includes('youtube.com')) {
      return parsed.searchParams.get('v');
    }
    
    return null;
  } catch {
    return null;
  }
}